var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StaticPage',{attrs:{"type":_vm.type}})
}
var staticRenderFns = []

export { render, staticRenderFns }